/**
 * Where the portal and this miniapp agree on which booking is open.
 *
 * A single `localStorage` entry on the HOST's origin, reached from here through the SDK's storage
 * bridge. Contract mirrored in tenant-portal's `shared/utils/selected-booking`; changing the key,
 * the shape or the window on one side silently stops the restore rather than breaking loudly.
 *
 * Storage rather than the host's url on purpose. Moving the portal's route repoints the iframe, so
 * mirroring the open booking into the path would reload the very frame being tracked.
 */
export const SELECTED_BOOKING_STORAGE_KEY = 'resource-booking.selected-booking';

/** Kept in step with the portal's `SELECTED_BOOKING_TTL_MS`. */
export const SELECTED_BOOKING_TTL_MS = 5 * 60 * 1000;

export interface StoredBookingSelection {
  /**
   * Empty means "nothing is open", written rather than removed because the SDK exposes
   * `setStorage` and `getStorage` and no remove -- this side can overwrite the entry but can never
   * delete it. Only the host can.
   */
  transactionUuid: string;
  hostBuildingUuid: string;
  savedAt: number;
}
